"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.News = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var axios_1 = __importDefault(require("axios"));
var react_2 = require("@chakra-ui/react");
var react_paginate_1 = __importDefault(require("react-paginate"));
var react_router_dom_1 = require("react-router-dom");
var query_string_1 = __importDefault(require("query-string"));
var layout_1 = require("../../../common/layout");
var PageNotFound_1 = require("../../../common/error/PageNotFound");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var useShop_1 = require("../../../common/hooks/useShop");
var scrollToTopButton_1 = require("../../../common/layout/components/scrollToTopButton");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var News = function () {
    var _a;
    var search = (0, react_router_1.useLocation)().search;
    var queryParams = query_string_1.default.parse(search);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_1.useParams)();
    var _b = (0, useShop_1.useShop)(), shopData = _b.shopData, isShopLoading = _b.isShopLoading, mainShopData = _b.mainShopData;
    var _c = (0, react_1.useState)(null), NewsDatas = _c[0], setNewsDatas = _c[1];
    var _d = (0, react_1.useState)(true), isNewsLoading = _d[0], setIsNewsLoading = _d[1];
    var _e = (0, react_1.useState)(0), pageCount = _e[0], setPageCount = _e[1];
    var _f = (0, react_1.useState)(Number(queryParams.page) || null), pageNum = _f[0], setPageNum = _f[1];
    var shopCode = (_a = params.shop_code) !== null && _a !== void 0 ? _a : "main";
    var path = "/api/news";
    if (params.shop_code)
        path += "/" + params.shop_code;
    var returnTop = function () {
        window.scrollTo({
            top: 0,
        });
    };
    (0, useSetMeta_1.useSetMeta)("\u304A\u77E5\u3089\u305B\u4E00\u89A7");
    var handlePageClick = function (event) {
        setIsNewsLoading(true);
        if ((!pageNum && event.selected !== 0) || pageNum) {
            returnTop();
            navigate("/" + shopCode + "/news?page=" + (event.selected + 1));
            setPageNum(event.selected + 1);
        }
    };
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get(path, { params: { page: queryParams.page, limit: 15 } })
            .then(function (response) {
            setNewsDatas(response.data.news);
            setPageCount(response.data.paginate.last_page);
            setIsNewsLoading(false);
        });
        setPageNum(Number(queryParams.page));
    }, [queryParams.page]);
    if (isShopLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    if (!shopData)
        return (react_1.default.createElement(layout_1.Layout, { headerUrl: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.logo_image },
            react_1.default.createElement(react_2.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
    return (react_1.default.createElement(layout_1.Layout, { headerUrl: shopData.logo_image, shopCode: shopData.code, isHeader: true, isFooter: true, isInquire: true, isLoading: isShopLoading },
        react_1.default.createElement(react_2.Container, { maxW: "container.md" },
            react_1.default.createElement(react_2.Box, { paddingTop: "2.5rem", paddingBottom: "3rem" },
                react_1.default.createElement(react_2.Text, { fontSize: "2.2rem", fontWeight: "bold", marginRight: "1.3rem" }, "\u304A\u77E5\u3089\u305B\u4E00\u89A7"),
                shopData.code !== "main" && (react_1.default.createElement(react_2.Text, { color: "gray", fontSize: "1.5rem", lineHeight: "1.5rem" }, shopData === null || shopData === void 0 ? void 0 : shopData.name))),
            react_1.default.createElement("hr", null),
            react_1.default.createElement(react_1.default.Fragment, null,
                !isNewsLoading ? (react_1.default.createElement(react_2.List, null, NewsDatas === null || NewsDatas === void 0 ? void 0 : NewsDatas.map(function (data) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_2.ListItem, { py: "2rem", px: "1rem" },
                            react_1.default.createElement(react_2.Box, { display: "flex", alignItems: "center" },
                                react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", marginRight: "1.3rem" }, data.released.year + "." + data.released.month + "." + data.released.day),
                                data.type === "important" && (react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", padding: "2px", marginRight: "1.3rem", color: "red", border: "1px", borderColor: "red" }, "\u91CD\u8981")),
                                shopData.code === "main" &&
                                    data.shop.code !==
                                        "main" && (react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", color: "gray" }, "" + data.shop.name))),
                            data.contents ? (react_1.default.createElement(react_2.Link, { href: "/" + data.shop.code + "/news/" + data.id, fontSize: "1.5rem", textDecoration: "underline" }, data.title)) : (react_1.default.createElement(react_2.Text, { fontSize: "1.5rem" }, data.title))),
                        react_1.default.createElement("hr", null)));
                }))) : (react_1.default.createElement(react_2.Box, null, "Loading....")),
                react_1.default.createElement(react_2.Box, { textAlign: "center", className: "paginate", padding: "2rem" },
                    react_1.default.createElement(react_paginate_1.default, { forcePage: pageNum ? pageNum - 1 : 0, breakLabel: "...", nextLabel: ">", onPageChange: handlePageClick, pageRangeDisplayed: 3, pageCount: pageCount, previousLabel: "<", renderOnZeroPageCount: undefined, activeClassName: "active", marginPagesDisplayed: 1 })))),
        react_1.default.createElement(scrollToTopButton_1.ScrollToTopButton, null)));
};
exports.News = News;
